var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeals = function SvgDeals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.766 15.441-3.66 2.177a2 2 0 0 1-2.74-.696l-3.831-6.44a2 2 0 0 1-.22-1.515l.741-2.918a2 2 0 0 1 2.431-1.446l2.918.741a2 2 0 0 1 1.226.916l3.831 6.44a2 2 0 0 1-.696 2.742Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.55 6.118a1.996 1.996 0 0 1 1.64-.3l2.917.741a2 2 0 0 1 1.227.916l3.83 6.44a2 2 0 0 1-.696 2.741l-3.659 2.177a2 2 0 0 1-2.741-.696l-1.005-1.69",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: "currentColor"
  })));
};
export default SvgDeals;